import { UICategory, UIService } from '../contexts/CategoryContext';

interface ObjectWithId {
  id: number | string;
}

/**
 * Helper method for sorting any array with a string or number id in ascending order. Should be used in combination with useMemo() for best performance.
 */
export function sortById<T extends ObjectWithId>(arrayToBeSorted: T[]): T[] {
  return arrayToBeSorted.sort((a: T, b: T) => (a.id > b.id ? 1 : -1));
}

/**
 * Helper method for sorting any array by prop in ascending order. Should be used in combination with useMemo() for best performance.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function sortByPropAsc<T extends Record<string, any>>(arrayToBeSorted: T[], propName: string): T[] {
  return arrayToBeSorted.sort((a: T, b: T) => (a[propName] > b[propName] ? 1 : -1));
}

/**
 * Helper method to sort specifically the categories
 * @param categories categories to be sorted
 */
export function sortCategories(categories: UICategory[]): UIService[] {
  return categories
    .reduce((acc: UIService[], cur) => {
      if (!cur.services) {
        return acc;
      }

      return [...acc, ...cur.services];
    }, [])
    .sort((a, b) => {
      if (a.isEssential && b.isEssential) {
        return a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1;
      }

      if (a.isEssential && !b.isEssential) {
        return -1;
      }

      if (!a.isEssential && b.isEssential) {
        return 1;
      }

      return a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1;
    });
}
